import { QueryFunctionContext } from '@tanstack/react-query';

import { ProductSearchService } from 'src/services/ProductSearchService';

export const QUERY_KEY = 'sets_config_product_by_key';

// Product search paging is 1-based; page 0 is rejected with a 400.
const LOOKUP_PAGE = 1;
const LOOKUP_LIMIT = 5;

// Resolves a product key to its current product (id + human-readable name) via product search.
// Returns null when nothing matches the key exactly, so the modal can gate confirm on a real product.
export const queryProductByKey = async (
    context: QueryFunctionContext<App.SetsConfigs.ProductLookupQueryKey, number>,
): Promise<MCP.Products.ProductSearch.Models.MatchingVersion | null> => {
    const { queryKey, signal } = context;
    const [, accessToken, productKey] = queryKey;

    if (!productKey) {
        return null;
    }

    const response = await ProductSearchService.getMatchingCurrentProducts(
        accessToken,
        { productKey },
        LOOKUP_PAGE,
        LOOKUP_LIMIT,
        signal,
    );

    const exactMatch = response.result
        ?.map((product) => product.matching_versions?.[0])
        .find((version) => version?.productId?.toUpperCase() === productKey.toUpperCase());

    return exactMatch ?? null;
};
